import styled, { css } from 'styled-components';

import { media } from '@/utils/mixin';
import Button from '@/components/Button';
import AlfaLeasingLogo from '@/assets/svg/alfaleasing.svg';

export const Component = styled.form`
  position: relative;
  padding: 30px 40px;
  width: calc(100vw - 20px);
  max-width: 738px;
  background: ${(props) => props.theme.white};
  border-radius: 10px;

  ${media.mobile(css`
    max-width: none;
    padding: 20px 10px;
  `)}
`;

export const Header = styled.div`
  display: flex;
  justify-content: center;
`;

export const Title = styled.p`
  display: flex;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  text-align: center;
  margin: 0 50px;
  color: ${(props) => props.theme.black200};
`;

export const StyledButton = styled(Button)`
  max-width: 185px;

  ${media.mobile(css`
    max-width: 220px;
  `)}
`;

export const StyledAlfaLeasingLogo = styled(AlfaLeasingLogo)`
  position: absolute;
  top: 28px;
  left: 40px;

  ${media.mobile(css`
    width: 34px;
    height: 34px;
    top: 17px;
    left: 10px;
  `)}
`;
